import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'glm-camera-preview',
  templateUrl: './camera-preview.component.html',
  styleUrls: ['./camera-preview.component.css'],
})
export class CameraPreviewComponent implements OnInit {
  @Input() selectedMetrics = [];
  @Input() disableMetrics = [];
  @Input() camera = {
    image_url: '',
    id: 0,
    name: '',
  };
  @Input() storeId = 0;
  @Input() type = 'checkbox';
  @Input() cameraChecked = () => {};
  constructor(private modalService: BsModalService) {}

  modalImage = '';
  imgModalRef: BsModalRef;
  imageFooter;

  ngOnInit(): void {}

  setDisableMetricsArgument() {
    let disableMetricsArgument = false;
    if (this.disableMetrics) {
      disableMetricsArgument =
        this.disableMetrics[this.storeId][this.camera.id];
    }
    return disableMetricsArgument;
  }

  closeImageModal() {
    this.imgModalRef.hide();
  }
  openImageModal(template: TemplateRef<any>, data: any) {
    this.imgModalRef = this.modalService.show(template);
    this.modalImage = data.image_url;
    this.imageFooter = data.title || data.name || '';
    this.imgModalRef.setClass('modal-lg');
  }
}
